import { render, staticRenderFns } from "./AboutCollectionOrder.vue?vue&type=template&id=497a9b44&scoped=true&"
import script from "./AboutCollectionOrder.vue?vue&type=script&lang=js&"
export * from "./AboutCollectionOrder.vue?vue&type=script&lang=js&"
import style0 from "./AboutCollectionOrder.vue?vue&type=style&index=0&id=497a9b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a9b44",
  null
  
)

export default component.exports